import { logEvent as firebaseLogEvent } from "firebase/analytics";
import { analyticsPromise } from "configuration";

/**
 * Log a Firebase Analytics event.
 * Safe to call anywhere (services, hooks, components) — not just inside React.
 *
 * Analytics may be unavailable in certain browser environments (e.g. Safari
 * with strict tracking prevention, or non-browser runtimes). In those cases
 * the call is a silent no-op so it never breaks the calling code path.
 *
 * @param {string} eventName  - Snake_case GA4 event name
 * @param {object} [params]   - Optional event parameters
 */
export async function logAnalyticsEvent(eventName, params = {}) {
  try {
    const analytics = await analyticsPromise;
    if (!analytics) return;
    firebaseLogEvent(analytics, eventName, params);
  } catch (e) {
    // Never let analytics failures surface to the user
    console.warn(`[Analytics] Failed to log "${eventName}":`, e);
  }
}
